export const SENDING_EMAIL = 'ACTIVATIONMODAL/SENDING_EMAIL';
export const SEND_EMAIL_ERROR = 'ACTIVATIONMODAL/SEND_EMAIL_ERROR';
export const SEND_EMAIL_SUCCESS = 'ACTIVATIONMODAL/SEND_EMAIL_SUCCESS';
export const EMAIL_VERIFIED = 'ACTIVATIONMODAL/EMAIL_VERIFIED';

export const sendingEmail = () => ({
  type: SENDING_EMAIL,
});

export const sendEmailSuccess = () => ({
  type: SEND_EMAIL_SUCCESS,
});

export const sendEmailError = error => ({
  type: SEND_EMAIL_ERROR,
  payload: new Error(error),
  error: true,
});

const sendVerificationEmail = () => (dispatch, _, { apiV2 }) => {
  dispatch(sendingEmail());

  return apiV2
    .requestActivationEmail('me')
    .then(() => {
      dispatch(sendEmailSuccess());
    })
    .catch(error => {
      dispatch(sendEmailError(error));
    });
};

export default sendVerificationEmail;
